export interface HomeKitProvisioningPlugin {
  getAccessStatus(): Promise<any>;
  hasRequestedHomeAccess(): Promise<any>;
  start(input: {deviceType: String}): Promise<any>;
  allowFromSettings(): Promise<any>;
}
